// extracted by mini-css-extract-plugin
export var accordionIcon = "style-mod--accordion-icon--df0a6";
export var accordionIconOpen = "style-mod--accordion-icon-open--af171";
export var bottomFooter = "style-mod--bottom-footer--b13bf";
export var contactCol = "style-mod--contact-col--5b243";
export var desktopView = "style-mod--desktop-view--7c569";
export var divider = "style-mod--divider--e7ae4";
export var flexRow = "style-mod--flex-row--734af";
export var footer = "style-mod--footer--f3440";
export var footerContainer = "style-mod--footer-container--8ed11";
export var footerContent = "style-mod--footer-content--e316c";
export var footerEmail = "style-mod--footer-email--1d6da";
export var footerFlag = "style-mod--footer-flag--dfd79";
export var footerForm = "style-mod--footer-form--a719f";
export var footerList = "style-mod--footer-list--484a8";
export var footerNewsletter = "style-mod--footer-newsletter--d1dcc";
export var footerPhone = "style-mod--footer-phone--652fc";
export var footerTitle = "style-mod--footer-title--5627f";
export var language = "style-mod--language--daba1";
export var leftSide = "style-mod--left-side--15801";
export var listTitle = "style-mod--list-title--c7f3b";
export var listUl = "style-mod--list-ul--5c7aa";
export var mobileView = "style-mod--mobile-view--5e9b7";
export var rightSide = "style-mod--right-side--46a51";
export var socialIcons = "style-mod--social-icons--572c3";